export const constants = {
  baseURL: "https://cdn-prod.mybharats.in/mybharat/assets/img/icon-android/",
  logoUrl: {
    mybharat:
      "https://cdn-prod.mybharats.in/mybharat/assets/img/yuva_landing/mybharatlogo_opt_2x.png",
  },
  pageNotFoundURL: "https://cdn-prod.mybharats.in/mybharat/assets/img/mybharat/404.svg",
};

export const skillsListArr = [
  { id: 1, skills: "ADAPTABILITY/FLEXIBILITY" },
  { id: 2, skills: "ANALYTICAL SKILLS" },
  {
    id: 3,
    skills: "ARTIFICIAL INTELLIGENCE AND MACHINE LEARNING SKILLS",
  },
  { id: 4, skills: "ATTENTION TO DETAIL" },
  { id: 5, skills: "BIG DATA ANALYTICS SKILLS" },
  { id: 6, skills: "BUSINESS DEVELOPMENT SKILLS" },
  { id: 7, skills: "CLOUD COMPUTING SKILLS" },
  { id: 8, skills: "COACHING AND MENTORING SKILLS" },
  { id: 9, skills: "COMMUNICATION SKILLS" },
  { id: 10, skills: "CONFLICT RESOLUTION SKILLS" },
  { id: 11, skills: "CREATIVITY" },
  { id: 12, skills: "CRISIS MANAGEMENT SKILLS" },
  { id: 13, skills: "CULTURAL AWARENESS SKILLS" },
  { id: 14, skills: "CUSTOMER RELATIONSHIP MANAGEMENT (CRM) SKILLS" },
  { id: 15, skills: "CUSTOMER SERVICE SKILLS" },
  { id: 16, skills: "CYBERSECURITY SKILLS" },
  { id: 17, skills: "DATA ANALYSIS SKILLS" },
  { id: 18, skills: "DATA ENTRY AND MANAGEMENT SKILLS" },
  { id: 19, skills: "DECISION-MAKING SKILLS" },
  { id: 20, skills: "EDUCATION SKILLS" },
  { id: 21, skills: "EMOTIONAL INTELLIGENCE SKILLS" },
  { id: 22, skills: "ENTREPRENEURSHIP SKILLS" },
  { id: 23, skills: "ENVIRONMENTAL SUSTAINABILITY SKILLS" },
  { id: 24, skills: "EVENT PLANNING SKILLS" },
  { id: 25, skills: "FINANCIAL MANAGEMENT SKILLS" },
  { id: 26, skills: "GRAPHIC DESIGN SKILLS" },
  { id: 27, skills: "HEALTHCARE SKILLS" },
  { id: 28, skills: "HUMAN RESOURCES SKILLS" },
  { id: 29, skills: "INTERPERSONAL SKILLS" },
  { id: 30, skills: "IT INFRASTRUCTURE AND NETWORKING SKILLS" },
  { id: 31, skills: "LANGUAGE SKILLS" },
  { id: 32, skills: "LEADERSHIP SKILLS" },
  { id: 33, skills: "LEGAL SKILLS" },
  { id: 34, skills: "MARKETING SKILLS" },
  { id: 35, skills: "MOBILE APP DEVELOPMENT SKILLS" },
  { id: 36, skills: "MULTITASKING" },
  { id: 37, skills: "NEGOTIATION SKILLS" },
  { id: 38, skills: "NETWORKING SKILLS" },
  { id: 39, skills: "OCCUPATIONAL HEALTH AND SAFETY SKILLS" },
  { id: 40, skills: "PROBLEM-SOLVING SKILLS" },
  { id: 41, skills: "PROCUREMENT SKILLS" },
  { id: 42, skills: "PROJECT COORDINATION SKILLS" },
  { id: 43, skills: "PROJECT MANAGEMENT SKILLS" },
  { id: 44, skills: "PUBLIC RELATIONS SKILLS" },
  { id: 45, skills: "QUALITY CONTROL AND ASSURANCE SKILLS" },
  { id: 46, skills: "RESEARCH AND DEVELOPMENT SKILLS" },
  { id: 47, skills: "RESEARCH SKILLS" },
  { id: 48, skills: "SALES MANAGEMENT SKILLS" },
  { id: 49, skills: "SALES SKILLS" },
  { id: 50, skills: "SEO AND SEM SKILLS" },
  { id: 51, skills: "SOCIAL MEDIA MANAGEMENT SKILLS" },
  { id: 52, skills: "SOFTWARE DEVELOPMENT SKILLS" },
  { id: 53, skills: "STATISTICAL ANALYSIS SKILLS" },
  { id: 54, skills: "STRATEGIC PLANNING SKILLS" },
  { id: 55, skills: "SUPPLY CHAIN LOGISTICS SKILLS" },
  { id: 56, skills: "SUPPLY CHAIN MANAGEMENT SKILLS" },
  { id: 57, skills: "TEAM BUILDING SKILLS" },
  { id: 58, skills: "TECHNICAL SKILLS" },
  { id: 59, skills: "TIME MANAGEMENT SKILLS" },
  { id: 60, skills: "WRITING SKILLS" },
];
